<div [formGroup]="formValidationGroup">
    <select [id]="validationIdentifier" class="form-control"
        [ngModel]="datafield?.Value?.toString() === '' ? null : $safeNavigationMigration(datafield?.Value?.toString())"
        (ngModelChange)="onModelChange($event)" [formControlName]="validationIdentifier">
        <option [ngValue]="null">Please select...</option>
        @for (datafieldChoice of datafield?.Choices; track $index) {
        <option [ngValue]="datafieldChoice.Value">{{datafieldChoice.DisplayValue}}</option>
        }
    </select>
    @if(!isValid){
    <div class="error">This field is required</div>
    }
</div>
